// Audit (CreatedBy/UpdatedBy) alanlarını okunur kullanıcı adına çözmek için paylaşılan
// yardımcı. Backend'ler bu alanlarda çoğunlukla kullanıcı KİMLİĞİ saklar ("5", "user:5")
// ya da e-posta ("halit@admin") / "system" gibi serbest metin. Kullanıcı listesini bir kez
// çekip (modül düzeyinde önbellek) id → "Ad Soyad" / e-posta eşlemesi kurar; eşleşme yoksa
// ham değer olduğu gibi gösterilir. Yetki yoksa (403) sessizce ham değere düşer.
import { authHeaders } from '../listPageStyles';

let _cache = null;
let _promise = null;

function unwrapArr(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.Data)) return payload.Data;
  if (Array.isArray(payload?.value)) return payload.value;
  return [];
}

export function loadAuditUserMap() {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = fetch('/api/users/Select', { headers: authHeaders() })
    .then((r) => (r.ok ? r.json() : []))
    .then((data) => {
      const map = {};
      unwrapArr(data).forEach((u) => {
        const id = String(u.id ?? u.Id ?? '');
        const email = (u.email ?? u.Email ?? '').trim();
        const name = [u.firstName ?? u.FirstName, u.lastName ?? u.LastName].filter(Boolean).join(' ').trim();
        const label = name || email || id;
        if (id) map[id] = label;                       // sayısal id ile eşle
        if (email) map[email.toLowerCase()] = label;   // e-posta ile de eşle (ör. halit@admin → Halit Dogmen)
      });
      _cache = map;
      return map;
    })
    .catch(() => ({}));
  return _promise;
}

// Saklanan değeri (id | "user:id" | e-posta | "system") okunur etikete çevirir.
// id VE e-posta ile eşleşme dener; hiçbiri tutmazsa ham değeri döndürür (hiçbir şey gizlenmez).
export function resolveAuditUser(value, map) {
  if (value === null || value === undefined || value === '') return '—';
  const sv = String(value);
  const idPart = sv.startsWith('user:') ? sv.slice(5) : sv;
  if (map) {
    if (map[idPart]) return map[idPart];               // sayısal id eşleşmesi
    if (map[sv.toLowerCase()]) return map[sv.toLowerCase()]; // e-posta eşleşmesi
  }
  return sv; // çözülemedi → ham değer (ozanselvi@… gibi hayalet değerler aynen görünür)
}
